import { IMessages } from "src/shared/FormAnswer/types/Messages";
import { QuestionId } from "src/type/form/question";
import { IDoc } from "src/shared/FormAnswer/types/Doc";
import { SectionId } from "src/type/form/section";
import { PossiblityId } from "src/type/form/possiblity";
import { route } from "src/conf/routes";
import { _CALL_API } from "src/core/middleware/api";
import { _CRUD, _API } from "./_Action";


interface InitParams {
  dateFormat: string;
  messages: IMessages;
  maxUploadFileSize: number;
  triggerOnChange: (qId: QuestionId) => void;
  onUploadFile: (f: File, callback: (uploadedFile: IDoc) => void) => void;
  readonly: boolean;
}

const _FORM = _CRUD('form')
const _FORM_VERSION = _API('qp_version')

export const formAction = {
  RESET_ANSWERS: 'form/RESET_ANSWERS',
  INIT: 'form/INIT',
  UPDATE_ANSWER: 'form/UPDATE_ANSWER',
  REMOVE_ANSWER: 'form/REMOVE_ANSWER',
  UPDATE_SECTION_VALIDITY: 'form/UPDATE_SECTION_VALIDITY',
  ADD_CHECKED_POSSIBILITY: 'form/ADD_CHECKED_POSSIBILITY',
  REMOVE_CHECKED_POSSIBILITY: 'form/REMOVE_CHECKED_POSSIBILITY',
  FETCH_FORM_REQUEST: 'form/FETCH_FORM_REQUEST',
  FETCH_FORM_SUCCESS: 'form/FETCH_FORM_SUCCESS',
  FETCH_FORM_FAILURE: 'form/FETCH_FORM_FAILURE',
  RESET_FORM: 'form/RESET_FORM',

  init: (params: InitParams) => dispatch => {
    dispatch({
      type: formAction.INIT,
      ...params
    });
  },

  fetchForm: (id: string, version: number) => dispatch => {
    return dispatch({
      [_CALL_API]: {
        types: [_FORM.GET.REQUEST, _FORM.GET.SUCCESS, _FORM.GET.FAILURE],
        route: route.form.get(id, version)
      }
    })
  },

  saveAnswer: (id: string, version: number, answers: any) => dispatch => {
    return dispatch({
      [_CALL_API]: {
        types: [_FORM.UPDATE.REQUEST, _FORM.UPDATE.SUCCESS, _FORM.UPDATE.FAILURE],
        route: route.form.update(id, version, answers)
      }
    })
  },

  getQPversion: (enterpriseId: string) => dispatch => {
    return dispatch({
      [_CALL_API]: {
        types: [_FORM_VERSION.REQUEST, _FORM_VERSION.SUCCESS, _FORM_VERSION.FAILURE],
        route: route.form.getFormVersion(enterpriseId)
      }
    })
  },

  resetForm: () => dispatch => {
    dispatch({
      type: formAction.RESET_FORM
    })
  },

  resetAnswers: () => dispatch => {
    dispatch({
      type: formAction.RESET_ANSWERS
    })
  },

  updateAnswer: (questionId: QuestionId, answer: string[]) => dispatch => {
    dispatch({
      type: formAction.UPDATE_ANSWER,
      questionId, answer,
    });
  },

  removeAnswer: (questionId: QuestionId) => dispatch => {
    dispatch({
      type: formAction.REMOVE_ANSWER,
      questionId
    });
  },

  updateSectionValidity: (sectionId: SectionId, questionId: QuestionId, isValid: boolean) => dispatch => {
    dispatch({
      type: formAction.UPDATE_SECTION_VALIDITY,
      sectionId, questionId, isValid
    });
  },

  addCheckedPossibility: (questionId: QuestionId, possiblityId: PossiblityId) => dispatch => {
    dispatch({
      type: formAction.ADD_CHECKED_POSSIBILITY,
      questionId, possiblityId
    });
  },

  removeCheckedPossibility: (questionId: QuestionId,) => dispatch => {
    dispatch({
      type: formAction.REMOVE_CHECKED_POSSIBILITY,
      questionId
    });
  }
};




// WEBPACK FOOTER //
// ./src/core/redux/action/formAction.ts